import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';
import { EnumGenericRoleActionAlerts } from '@pages/BasePage';

@Component({
    selector: 'app-next-draft',
    templateUrl: './next-draft.component.html',
    styleUrls: ['./next-draft.component.scss'],
})
export class NextDraftModalComponent implements OnInit {

    public Campaigns: any[] = [];
    public AwardsData: any[] = [];

    public SelectedCampaign: any = null;
    public SelectedDraftMomentId: string;
    public SelectedDraftMoment: any;

    public IsDrafting: boolean = false;
    private onGetAwards: Function;
    private onProcessDraft: Function;

    constructor(
        private NavParams: NavParams,
        private ModalController: ModalController
    ) {

        this.Campaigns = this.NavParams?.get('campaigns') || [];
        this.onGetAwards = this.NavParams?.get('onGetAwards') || null;
        this.onProcessDraft = this.NavParams?.get('onProcessDraft') || null;


    }

    async ngOnInit() {


        console.log(this.Campaigns);

        if (this.Campaigns?.length > 0)
            this.SelectedCampaign = this.Campaigns[0];

        // for tests
        // this.SelectedCampaign.DraftMomentList[0].WasProcessed = true;

        this.SelectedDraftMoment = this.SelectedCampaign?.DraftMomentList
            ?.sort((a, b) => {
                return new Date(a.ProcessDate).getTime() - new Date(b.ProcessDate).getTime();
            })
            .find(it => new Date(it.ProcessDate).getTime() > new Date().getTime());




        if (!this.onGetAwards) return;

        const responseAwards: any[] = await this.onGetAwards(this.SelectedDraftMoment.Id);

        this.AwardsData = responseAwards || [];

    }

    public OnChangeMoment(ev: any) {

        const idDraftMoment = ev?.detail?.value || null;

        console.log(idDraftMoment);

        this.SelectedDraftMoment = this.SelectedCampaign?.DraftMomentList?.find(it => (it.Id).toLowerCase() == (idDraftMoment).toLowerCase());

        if (!idDraftMoment) return;

    }

    public async OnStartDraft(ev) {

        if (this.SelectedDraftMoment?.WasProcessed) return;

        this.IsDrafting = true;


        const t = setTimeout(() => { clearTimeout(t); this.IsDrafting = false }, 2000);

        if (!this.onProcessDraft) return;

        const response = await this.onProcessDraft(this.SelectedDraftMoment.Id);

        // if(response)
        const responseAwards: any[] = await this.onGetAwards(this.SelectedDraftMoment.Id);

        this.AwardsData = responseAwards || [];


    }

    OnView(ev: any, item) {

        
    }

    Close() {
        // using the injected ModalController this page
        // can "dismiss" itself and optionally pass back data
        this.ModalController.dismiss(null, EnumGenericRoleActionAlerts.Close);
    }
}
